import { Injectable } from '@angular/core';

import { DataQueryWithTagDtoWithRelations } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { DataQueryPresenterModel } from '@osos/shared/types';
import { QueryParseV1Service } from '../../parsers';

@Injectable({
  providedIn: 'root',
})
export class QueryFactoryService extends FactoryBase<
  DataQueryWithTagDtoWithRelations,
  DataQueryPresenterModel
> {
  constructor(parserFactory: ParserFactory, parser_v1: QueryParseV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: DataQueryPresenterModel,
  ): DataQueryWithTagDtoWithRelations {
    const parser = this.getParser(
      DataQueryWithTagDtoWithRelations,
      DataQueryPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(
    model: DataQueryWithTagDtoWithRelations,
  ): DataQueryPresenterModel {
    const parser = this.getParser(
      DataQueryWithTagDtoWithRelations,
      DataQueryPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
